// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import IconButton from '../IconButton';

import './Panel.less';

/**
 * Panel component.
 */
class Panel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: this.props.collapsible && this.props.collapsed,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { collapsed } = nextProps;
        if (this.state.collapsed !== collapsed) {
            this.setState({ collapsed });
        }
    }

    handleToggle = () => {
        this.setState(({ collapsed }) => ({
            collapsed: !collapsed,
        }), () => {
            if (this.props.onToggle) {
                this.props.onToggle(this.state.collapsed);
            }
        });
    };

    render() {
        const { baseClassName, className, title, collapsible, children } = this.props;
        const { collapsed } = this.state;

        return (
            <div
                className={classNames(
                    baseClassName,
                    {
                        [`${baseClassName}--collapsible`]: collapsible,
                        [`${baseClassName}--collapsed`]: collapsed,
                        [`${baseClassName}--expanded`]: !collapsed,
                    },
                    className,
                )}
            >
                {title && (
                    <div className={`${baseClassName}__header`} onClick={this.props.collapsible ? this.handleToggle : null}>
                        <h4 className={`${baseClassName}__title`}>{title}</h4>
                        {this.props.collapsible && (
                            <IconButton
                                className={classNames(
                                    `${baseClassName}__control-button`,
                                    `${baseClassName}__control-button--collapse`
                                )}
                                icon={{ name: 'chevron-down', flipVertical: collapsed }}
                            />
                        )}
                    </div>
                )}
                <div className={`${baseClassName}__content`}>
                    {children}
                </div>
            </div>
        );
    }
}
Panel.propTypes = {
    /**
     * Panel title.
     */
    title: PropTypes.node,
    /**
     * Is panel collapsible.
     */
    collapsible: PropTypes.bool,
    collapsed: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Panel.defaultProps = {
    title: null,
    collapsible: false,
    collapsed: false,
    onToggle: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}panel`,
};

export default Panel;



// WEBPACK FOOTER //
// ./components/Panel/Panel.js